import React, { useState } from "react";
import "../../assets/css/login.css";
import { Container, Row, Col } from "react-bootstrap";
import loginImg from "../../assets/img/admin-login.png";
import { useNavigate } from "react-router-dom";
import { errorToaster, successToaster } from "../../utils";
import { ToastContainer } from "react-toastify";
import apiClient from "../../utils/api";

export const AdminLogin = () => {
  let nav = useNavigate();
  const [data, setData] = useState({
    id: "",
    password: "",
  });

  function changeHandler(e) {
    const arr = { ...data };
    arr[e.target.id] = e.target.value;
    setData(arr);
  }

  const adminLoginData = () => {
    let adminInfo = { ...data };

    apiClient
      .post(
        `get/auth.php`,
        {
          id: adminInfo.id,
          password: adminInfo.password,
        })
      .then((res) => {
        if (res.data.status === 1) {
          localStorage.setItem("token", res.data.token);
          localStorage.setItem("userId", adminInfo.id);
          nav("/landing");
          successToaster({ msg: "Login successful" });
        } else {
          localStorage.removeItem("token");
          localStorage.removeItem("userId");
          errorToaster({ msg: "Login failed" });
        }
      });
  };


  return (
    <div id="admin-login-div">
      <Container>
        <Row style={{ margin: "0", padding: "0" }}>
          <Col xl={1}></Col>
          <Col xl={10}>
            <Row id="total-admin">
              <Col
                xxl={6}
                xl={6}
                lg={6}
                md={6}
                id="admin-img"
                className="d-none d-sm-block"
              >
                <img
                  src={loginImg}
                  alt="admin q-makers"
                  className="img-fluid"
                />
              </Col>
              <Col xxl={6} xl={6} lg={6} md={6} id="login-contents">
                <div id="titles">
                  <h4>Login..!</h4>
                  <p>Welcome Back</p>
                </div>
                <div id="forms">
                  <p>Username</p>
                  <input
                    type="text"
                    placeholder="Enter username"
                    onChange={(e) => changeHandler(e)}
                    id="id"
                    value={data.id}
                  />
                  <p className="mt-2">Password</p>
                  <input
                    type="password"
                    placeholder="Enter password"
                    onChange={(e) => changeHandler(e)}
                    id="password"
                    value={data.password}
                  />
                  <button className="my-3" onClick={adminLoginData}>
                    Login
                  </button>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
      <ToastContainer />
    </div>
  );
};
